module.exports = __webpack_public_path__ + "res/ic_login.bf539a13ab2583fcdddd938aee0520a6.png";